<section class="portfolio section" id="portfolio">
  <h2 class="section__title">Portfolio</h2>
  <span class="section__subtitle">Most recent work</span>

  <div class="portfolio__container container">
    <div>
      <swiper [config]="config">
        <div class="swiper-wrapper">
          <!-- Portfolio 1 -->
          <div class="portfolio__content swiper-slide">
            <img src="./../../../assets/img/Screenshot (780).png" alt="img 1" class="portfolio__img">

            <div class="portfolio__data">
              <h3 class="portfolio__title">Profile Card</h3>
              <p class="portfolio__description"></p>

              <a href="https://profile-card-woad-chi.vercel.app/" target="_blank"
                class="button button--flex button-small portfolio__button">View
                <i class="uil uil-arrow-right button__icon"></i></a>
            </div>
          </div>

          <!-- Portfolio 2 -->
          <div class="portfolio__content swiper-slide">
            <img src="./../../../assets/img/Screenshot (776).png" alt="img 1" class="portfolio__img">

            <div class="portfolio__data">
              <h3 class="portfolio__title">Todo App</h3>
              <p class="portfolio__description"></p>

              <a href="https://todo-app-two-plum.vercel.app/" class="button button--flex button-small portfolio__button">
                View
                <i class="uil uil-arrow-right button__icon"></i>
              </a>
            </div>
          </div>

          <!-- Portfolio 3 -->
          <div class="portfolio__content swiper-slide">
            <img src="./../../../assets/img/Screenshot (777).png" alt="img 1" class="portfolio__img">

            <div class="portfolio__data">
              <h3 class="portfolio__title">Weather</h3>
              <p class="portfolio__description"></p>

              <a href="https://weather-angular-cyan.vercel.app/" class="button button--flex button-small portfolio__button">
                View
                <i class="uil uil-arrow-right button__icon"></i>
              </a>
            </div>
          </div>

          <!-- Portfolio 4 -->
          <div class="portfolio__content swiper-slide">
            <img src="./../../../assets/img/Screenshot (779).png" alt="img 1" class="portfolio__img">

            <div class="portfolio__data">
              <h3 class="portfolio__title">Animated Card</h3>
              <p class="portfolio__description"></p>

              <a href="https://animated-card.vercel.app/" class="button button--flex button-small portfolio__button">
                View
                <i class="uil uil-arrow-right button__icon"></i>
              </a>
            </div>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
        <!-- Add Arrows -->
        <div class="swiper-button-next">
          <i class="uil uil-angle-right-b swiper-portfolio-icon"></i>
        </div>
        <div class="swiper-button-prev">
          <i class="uil uil-angle-left-b swiper-portfolio-icon"></i>
        </div>
      </swiper>
    </div>
  </div>
</section>
